import { apiClient } from '~/api/client'
import type { UserBulkResult } from '~/api/types'

// 사용자 관리 API. 단건 역할 변경은 페이지가 PUT /users/{id}로 직접 호출하고,
// 여기서는 선택 항목 일괄 처리만 다룬다(카탈로그 bulk 패턴과 동일 톤).

/** 사용자 권한 역할. user < admin < superadmin. */
export type UserRole = 'user' | 'admin' | 'superadmin'

/** POST /admin/api/users/bulk — 선택한 사용자들의 역할을 한 번에 같은 값으로 변경(superadmin).
 *  단건 PUT을 여러 번 보내는 대신 서버에서 일괄 처리한다. 마지막 superadmin 강등 등 보호
 *  규칙은 서버가 판단하며, 적용하지 못한 건은 {id,error}로 모여 토스트에 실패 수로 표시된다. */
export function bulkUpdateUserRole(ids: string[], role: UserRole) {
    return apiClient.post<UserBulkResult>('/users/bulk', { ids, role })
}

/** PUT /admin/api/users/{id}/password {newPassword} — superadmin이 사용자 비밀번호를 재설정(이메일
 *  복구가 없어 콘솔에서 처리). 평문은 전송만 하고 어디에도 저장/노출하지 않는다. 성공 시 204(본문 없음).
 *  8자 미만/불일치 검증은 호출 측(모달)이 먼저 거르고, 정책 위반(400)·미존재(404)는 ApiError로 던져진다. */
export function resetUserPassword(id: string, newPassword: string) {
    return apiClient.put<void>(`/users/${id}/password`, { newPassword })
}
